module.exports = "/images/garage.png?ab9a65b2c7c4bee427f3e71d850e5ebb";